module.exports = __webpack_public_path__ + "img/102.eb177a37.jpg";